import { useEffect, useState } from 'react'
import { ReactComponent as ErrorSvg } from '../../../../assets/svg/error.svg'

const ExpiredScreen = ({ redirectUrl }) => {
  const [countdown, setCountdown] = useState(20)

  useEffect(() => {
    if (!redirectUrl) return

    if (countdown === 0) {
      window.location.replace(redirectUrl)
      return
    }

    const timer = setTimeout(() => setCountdown((c) => c - 1), 1000)
    return () => clearTimeout(timer)
  }, [countdown, redirectUrl])

  return (
    <div
      style={{ height: '690px' }}
      className='d-flex justify-content-center align-items-center'
    >
      <div style={{ maxWidth: '300px' }} className='w-100'>
        <ErrorSvg />

        <h5 className='fw-bold mb-4'>Session Expired</h5>

        <div
          style={{
            border: '1px solid #EAECF0',
            background: '#FCFCFD',
            padding: '12px 20px',
          }}
          className='d-flex align-items-start rounded'
        >
          <p
            style={{ color: '#667085', fontSize: '12px' }}
            className='small flex-fill'
          >
            This checkout session has expired, please contact the service
            provider
          </p>
        </div>

        {redirectUrl && (
          <p
            style={{ color: '#667085', fontSize: '12px' }}
            className='text-center mt-3'
          >
            Redirecting in {countdown} second{countdown !== 1 ? 's' : ''}...
          </p>
        )}
      </div>
    </div>
  )
}

export default ExpiredScreen
